import axios from 'axios';
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import Dashboard from '~/layouts/Dashboard';
import SelectClients, { SelectClientsPropsRef } from './SelectClients';
import { useToast } from '~/hooks/toast';

interface Params {
  id: string;
}

const { REACT_APP_FIREBASE_PROJECT, REACT_APP_CHATBOT_WPP } = process.env;

const Promoter: React.FC = () => {
  const { addToast } = useToast();
  const params = useParams<Params>();
  const { id } = params;
  const selectClientsRef = React.useRef<SelectClientsPropsRef>(null);

  const [message, setMessage] = useState<string>('');
  const [image, setImage] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    const selectedClients = selectClientsRef.current?.get();
    if (!image || !message || !selectedClients || selectedClients.length === 0)
      return;

    setLoading(true);

    const formData = new FormData();
    formData.append('image', image);
    formData.append('message', message);
    formData.append('clients', JSON.stringify(selectedClients));

    try {
      await axios.post(
        `${REACT_APP_CHATBOT_WPP}/session/${REACT_APP_FIREBASE_PROJECT}/send-media-message`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      addToast({
        type: 'success',
        description: 'Mensagem enviada com sucesso!',
      });
    } catch (error) {
      console.error('Erro ao enviar mensagem:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dashboard containerMessage="col-xl-6 offset-xl-3 col-md-10 offset-md-1">
      <div className="col-xl-6 offset-xl-3 col-md-10 offset-md-1">
        <h4>Divulgador</h4>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 pt-4">
            <SelectClients ref={selectClientsRef} />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 pt-4">
            <div className="form-group mb-3">
              <label className="form-label">Anexe a Imagem</label>
              <div className="form-control-wrap">
                <input
                  type="file"
                  id="photo"
                  style={{ width: '100%' }}
                  onChange={e => setImage(e.target.files?.[0] || null)}
                />
              </div>
            </div>

            {/* <input
            type="file"
            onChange={e => setImage(e.target.files?.[0] || null)}
          /> */}
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="default-textarea">
                Descrição
              </label>
              <div className="form-control-wrap">
                <textarea
                  className="form-control no-resize"
                  id="default-textarea"
                  placeholder="Escreva a mensagem que deseja enviar para os clientes..."
                  defaultValue={message}
                  rows={15}
                  onChange={event => {
                    setMessage(event.target.value);
                  }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                onClick={handleSend}
                className="btn btn-lg btn-primary"
                disabled={loading}
              >
                {loading && (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                )}
                {!loading && 'Enviar Mensagem'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default Promoter;
